export const getCommercialCount = durationTime => {
    const duration = Number(durationTime);
    if (duration <= 15) return 2;
    if (duration === 30) return 4;
    if (duration === 60) return 8;
};
